import React from "react";
import Sidebar from "../PPT/Sidebar";

function EditSlide({ isOpen, setIsOpen, onEditSlide }) {
  return (
    <Sidebar
      open={isOpen}
      setOpen={setIsOpen}
      rightCTA={'Edit Slide'}
      title="Edit Slide 1"
      onConfirm={() => {
        onEditSlide();
        setIsOpen(false)
      }}
    >
      <div>
        <h2 className="text-base font-bold mb-4">Edit Slide</h2>
        Work in progress , Detecting Slide info and loading UI according to the Items on slide
      </div>
    </Sidebar>
  );
}

export default EditSlide;
